import TableLoading from "./TableLoading";

export default function TableLoadingState({ more = false, className = "" }) {
  return (
    <div role="status" aria-live="polite" className={`w-full flex justify-center items-center gap-2 py-4 text-[#808080] ${className}`}>
      {!more && <span>در حال بارگذاری</span>}
      <TableLoading />
    </div>
  );
}
